module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "requestcard"
  }, [_c('MentoringTopCard', {
    attrs: {
      "status": _vm.statusText,
      "teamTitle": _vm.teamTitle
    }
  }), _c('MentoringMain', {
    attrs: {
      "title": _vm.title,
      "status": _vm.iconStatus,
      "isOpened": _vm.isOpenList,
      "curator": _vm.curator,
      "mentor": _vm.mentor,
      "list": _vm.list,
      "startDate": _vm.startDate
    }
  }), _c('MentoringCardFooter', {
    attrs: {
      "text": _vm.btnText,
      "isButton": true
    },
    on: {
      "toggleDescription": _vm.toggleList
    }
  }, [_c('Small', {
    attrs: {
      "slot": "firstColumn"
    },
    slot: "firstColumn"
  }, [_vm._v(_vm._s(_vm.isCompleted))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52b6775c","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/programcard/MentoringProgramCard.vue
// module id = 2fa4d42085b01b0e91ec
// module chunks = 89